import "./NotFound.css";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export const NotFound = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>VH BuildUp! - 404</title>
      </Helmet>
      <div className="notFound">
        <div>
          <h1>404</h1>
          <h2>{t("page_not_found.title")}</h2>
          <p>{t("page_not_found.text", { url: pathname })}</p>
        </div>
        <Link className="link-button" to="/">
          HOME
        </Link>
      </div>
    </>
  );
};
